import { render, staticRenderFns } from "./AddReward.vue?vue&type=template&id=2613ca25&scoped=true&"
import script from "./AddReward.vue?vue&type=script&lang=js&"
export * from "./AddReward.vue?vue&type=script&lang=js&"
import style0 from "./AddReward.vue?vue&type=style&index=0&id=2613ca25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613ca25",
  null
  
)

export default component.exports